import api from '@motionelements/core/src/api/base-api-v2';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

const baseUrl = '/v2/payment-intents';

// eslint-disable-next-line
export const createPaymentIntents = params => {
  return api.request('post', baseUrl, {
    data: {
      ...params,
    },
    params: {
      ...api.getLocaleParams(),
      ...(!featureFlagMixin.methods.isFeatureEnabled('new_paypal') && params.paymentMethodType === 'paypal' && { type: 'paypal' }),
    },
  });
};

// eslint-disable-next-line
// complete after js confirmCardPayment
export const completePaymentIntents = (orderId, params) => api.request('post', `${baseUrl}/${orderId}/complete`, {
  data: {
    ...params,
  },
  params: api.getLocaleParams(),
});

export const confirmPaymentIntents = (paymentIntentId, params) => {
  const url = `${baseUrl}/${paymentIntentId}/confirm`;
  return api.request('post', url, {
    data: {
      ...params,
    },
    params: api.getLocaleParams(),
  });
};
